import React from "react";

function Employment() {
  window.scrollTo(0, 0);
  return (
    <div>
     
<section className="ftco-section" style={{padding:"0px"}}>
    <div className="container">
      <div className="row mb-5  mx-auto">
        <div className="heading-section ftco-animate fadeInUp ftco-animated">
        <h2 style={{color:"#3A3A3A"}}><b>Employment</b></h2>
            <div style={{color:"#5E5550"}}>
              <p>
              This area of law is as long as a piece of string.  It involves anything to do with employees.
              </p>
              <p>
              Whether it is the employee or employer in question this area has been heavily covered in our firm.  
              </p>
              <p>
              The firm has been involved with drafting contracts for new coming employees on behalf of employers.  On the other hand the firm has been involved in preparing settlement agreements and advising on the termination of employees for clients wishing to go through redundancies.
              </p>
              <p>
              We have also lodged labor cases on behalf of individuals who felt they were unfairly dealt with by their employers.  On the contrary we have defended clients who were facing labor cases by their former employees in respect of employment disputes.
              </p>
            </div>
        </div>
      </div>
    </div>
  </section>
</div>
  );
}

export default Employment;
